import { dmaMap } from "@/mockData/dma";
import { Project, Scenario } from "@/types/project";

const listValues = (values?: string[] | null): string[] => (Array.isArray(values) ? values.filter(Boolean) : []);

export const findScenarioById = (project: Project | null, scenarioId: string): Scenario | undefined => {
  if (!project || !scenarioId) return undefined;

  for (const goal of project.business_goals ?? []) {
    for (const plan of goal.plans ?? []) {
      for (const scenario of plan.scenarios ?? []) {
        if (String(scenario.id) === scenarioId) return scenario;
      }
    }
  }

  return undefined;
};

export const buildGeographyExportValue = (scenario?: Scenario, fallback = ""): string => {
  const states = listValues(scenario?.states);
  const dma = listValues(scenario?.dma).map((code) => dmaMap[code] ?? code);
  const cities = listValues(scenario?.cities);
  const zipCodes = listValues(scenario?.zip_codes);

  if (!dma.length && !cities.length && !zipCodes.length) {
    return states.length ? states.join(", ") : fallback;
  }

  const sections: string[] = [];
  if (states.length) sections.push(`States: ${states.join(", ")}`);
  if (dma.length) sections.push(`DMAs: ${dma.join(", ")}`);
  if (cities.length) sections.push(`Cities: ${cities.join(", ")}`);
  if (zipCodes.length) sections.push(`ZIP codes: ${zipCodes.join(", ")}`);

  return sections.join(" | ");
};
